//
//
//
//
//
//
//
//
//
//
//

import { MOBILE, TABLET } from '@/scripts/constants/media-query'
import RbProductTileAttributesElement from '@/elements/product-tile/product-tile-content/product-tile-attributes/product-tile-attributes-element/product-tile-attributes-element.vue'
export default {
  name: 'product-tile-attributes',
  components: {
    RbProductTileAttributesElement,
  },
  inject: ['isLoading'],
  props: {
    attributes: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    isMobile() {
      return [MOBILE, TABLET].includes(this.$mq)
    },
    attributesMap() {
      if (this.attributes?.length) {
        if (this.isMobile) {
          return [this.attributes[0]]
        } else {
          return [this.attributes[0], this.attributes[1]]
        }
      }
      return []
    },
  },
}
